import React from "react";
import "./styles/WhatWeDo.css";

const cardData = [
  {
    icon: "💬",
    title: "Goat Teachers",
    description:
      "Goat Teachers allows university students to rate and review their university and faculty members based on real experiences. Promote transparency, accountability, and smarter academic choices through public feedback.",
    link: "/rating-network",
  },
];

const WhatWeDo = () => {
  return (
    <section className="what-we-do" aria-labelledby="what-we-do-heading">
      {/* Decorative overlay for contrast */}
      <div className="what-we-do__overlay" aria-hidden="true" />

      <div className="what-we-do__container">
        <header className="what-we-do__header">
          <h2 id="what-we-do-heading" className="what-we-do__title">
            What Makes Us Different
          </h2>
          <p className="what-we-do__subtext">
            Trust Issues? Same. That’s Why We Built Goatt.
          </p>
        </header>

        <div className="what-we-do__grid" role="list">
          {cardData.map((card, index) => {
            const isExternal =
              Boolean(card.external) || card.link?.startsWith("http");
            return (
              <a
                key={index}
                className="wwd-card"
                href={card.link}
                role="listitem"
                aria-label={`${card.title} — ${card.description}`}
                {...(isExternal ? { rel: "noopener noreferrer" } : {})}
              >
                <div className="wwd-card__badge" aria-hidden="true">
                  {index + 1}
                </div>

                <div className="wwd-card__icon" aria-hidden="true">
                  {card.icon}
                </div>

                <h3 className="wwd-card__title">{card.title}</h3>
                <p className="wwd-card__desc">{card.description}</p>

                <span className="wwd-card__cta" aria-hidden="true">
                  {isExternal ? "Visit" : "Explore"} →
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
